module.exports = __webpack_public_path__ + "img/foto_oostkant.a68ef6ef.jpg";